import { render, staticRenderFns } from "./RatingConfiguratorTable.vue?vue&type=template&id=8795de94&"
import script from "./RatingConfiguratorTable.vue?vue&type=script&lang=js&"
export * from "./RatingConfiguratorTable.vue?vue&type=script&lang=js&"
import style0 from "./RatingConfiguratorTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
